import styled from 'styled-components'

export const ColumnTitle = styled.h3`
  padding: .5rem;
  padding-left: .5rem;
  padding-right: .3rem;
  border-radius: .5rem;
  transition: 250ms;
`